module.exports = __webpack_public_path__ + "static/media/picture_rade_hover.fb228bc2.jpg";